import { render } from "./Formato1997.vue?vue&type=template&id=009f0318&scoped=true"
import script from "./Formato1997.vue?vue&type=script&lang=js"
export * from "./Formato1997.vue?vue&type=script&lang=js"

import "./Formato1997.vue?vue&type=style&index=0&id=009f0318&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009f0318"]])

export default __exports__